import React, {useState} from 'react'
import {CircularProgress, IconButton, Tooltip} from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import {useShowError} from '@hooks/useShowError/useShowError'
import {getRecordingUrlApi} from '@containers/monitoringPlatform/geoZones/api/api'

interface IProps {
	accountId: number
	recordingId: number
	fileName?: string
}

export const DownloadRecordingButton = ({accountId, recordingId, fileName}: IProps) => {
	const {onShowError} = useShowError()
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const handleDownload = async () => {
		if (isLoading) {
			return
		}
		setIsLoading(true)
		try {
			const data = await getRecordingUrlApi({accountId, recordingId}, onShowError)
			if (data?.url) {
				const link = document.createElement('a')
				link.href = data.url
				link.download = fileName || `recording-${recordingId}.ts`
				link.target = '_blank'
				link.rel = 'noopener noreferrer'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Tooltip title="Завантажити відео">
			<span>
				<IconButton
					size="small"
					color="primary"
					onClick={handleDownload}
					disabled={isLoading}
				>
					{isLoading
						? <CircularProgress size={16}/>
						: <DownloadIcon fontSize="small"/>
					}
				</IconButton>
			</span>
		</Tooltip>
	)
}

export default DownloadRecordingButton
